<template>
  <div class="payment-item-container">
    <div class="sby-usage-list">
      <van-radio-group
        v-model="value"
        @change="changeSelect"
      >
        <cell-group>
          <cell
            v-for="(item, index) in item_list"
            :key="index"
          >
            <van-radio
              :name="index"
              :key="index"
            >
              <div>
                {{item.name}}
                <span class="text-gray">{{item.desc}}</span>
              </div>
              <div class="margin-bottom-5 margin-top-5">
                <van-tag
                  type="primary"
                  plain
                  class="small-tag margin-right-10"
                  v-for="(name, index) in items(item.items)"
                  :key="index"
                >{{name}}</van-tag>
                <van-tag
                  type="success"
                  plain
                  class="small-tag margin-right-10"
                  v-if="termDesc(item.term)"
                >{{termDesc(item.term)}}</van-tag>

                <van-tag
                  type="danger"
                  plain
                  class="small-tag margin-right-10"
                  v-for="(name, index) in item.tags"
                  :key="index"
                >{{name}}</van-tag>
              </div>
            </van-radio>
          </cell>
        </cell-group>
      </van-radio-group>
    </div>
    <div class="clear"></div>
  </div>
</template>

<script>
import _ from "lodash";
import {
  Toast,
  version,
  Dialog,
  CheckboxGroup,
  Icon,
  Checkbox,
  Cell,
  CellGroup
} from "vant";
import Vue from "vue";

import {
  PaymentWayList,
  CensusTypeList,
  PaymentItemEx,
  PaymentItemExList,
  PaymentWay,
  PaymentTerm,
  PaymentPaybackItemExList,
  PaymentTermList,
  LocationsRandom
} from "../pages/util/state_desc";

Vue.use(Checkbox).use(CheckboxGroup);

export default {
  name: "sby-usage-container",
  components: {
    Icon,
    Cell,
    CellGroup
  },
  props: {},
  model: {
    event: "change"
  },
  data() {
    return {
      item_list: [],
      value: []
    };
  },
  mounted() {
    this.loadUsages();
  },
  methods: {
    loadUsages() {
      this.$http.get("/api/common/usages").then(response => {
        this.item_list = response.data.data;
      });
    },
    termDesc(term) {
      return PaymentTerm[term];
    },
    changeSelect(index) {
      let indexs = [index];
      let paymentItems = new Set();
      let payment_way = "normal"; // 默认代缴
      let usages = [];
      let payment_term = "";

      for (let index of indexs) {
        this.item_list[index].items.forEach(item => paymentItems.add(item));
        if (this.item_list[index].way) {
          payment_way = this.item_list[index].way;
        }
        payment_term = this.calPaymentTerm(
          payment_term,
          this.item_list[index].term
        );
        usages.push(this.item_list[index]);
      }
      let payments = {
        payment_way: payment_way,
        payment_term: payment_term,
        payment_items: Array.from(paymentItems),
        payment_usage: usages,
      };
      this.$emit("change", payments);
    },
    calPaymentTerm(curTerm, newTerm) {
      if (curTerm === "year" || newTerm === "year") {
        return "year";
      }
      if (curTerm === "halfyear" || newTerm === "halfyear") {
        return "halfyear";
      }
      return newTerm;
    },
    getRandomInt(max) {
      return Math.floor(Math.random() * Math.floor(max));
    },
    items(items) {
      const item_descs = [];

      for (let item of items) {
        item_descs.push(PaymentItemEx[item]);
      }
      return item_descs;
    }
  }
};
</script>



<style lang="less" scoped>
@import "../assets/less/var.less";
.sby-usage-list {
  height: 100%;
  overflow-y: auto;
  padding-bottom: 10px;
  box-sizing: border-box;
  background-color: white;

  .van-cell__value {
    color: #333;
    position: relative;
  }

  .van-radio__label {
    margin-left: 32px;
  }

  .van-radio__input {
    top: 50%;
    left: 0;
    position: absolute;
    transform: translate(0, -50%);
  }

  .van-icon-checked {
    color: #38f;
  }

  &__text {
    margin: 0;
    color: #333;
    font-size: 14px;
    line-height: 1.5;
  }

  &__edit {
    position: absolute;
    top: 50%;
    right: 15px;
    font-size: 20px;
    color: #999;
    transform: translate(0, -50%);
  }

  &__add {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9999;
    font-weight: 500;
    line-height: 36px;
    padding-left: 15px;
    font-size: 16px;

    .van-icon-add {
      color: #38f;
      font-size: 20px;
      line-height: 1.7;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/sby-usage-container.vue